exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mhd--modal--close .close {\n  opacity: 1;\n  margin-top: 2px; }\n\n.mhd--divider-wrapper {\n  padding: 0 45px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Structure/modal.scss
// module id = 1301
// module chunks = 1